import { axiosClient } from "../../api/api";

export const getsurveysPointApi = async (sessionIdParam: string, rating?:number, uid? : string) => {
  return axiosClient
    .post("/api/survey/getSurvey_Complete_Point", {
      session_id : sessionIdParam,
      rating:rating,
      uid: uid
    })
    .then((response) => response.data);
};


export const updateEmailOfPanelistApi = async (uid: string | number, email : string, sessionId: string, type: string, name: string, password: string, ipAddressName: string, countryName: string, form: any) => {
  return axiosClient
    .post("/api/survey/updateEmailOfPanelistApi", {
      uid : uid,
      email: email,
      sessionId: sessionId,
      type: type,
      name: name,
      password: password,
      ipAddressName: ipAddressName,
      countryName: countryName,
      ...form
    })
    .then((response) => response.data);
};

export const insertOtpForExistEmailApi = async (email: string) => {
  return axiosClient
    .post("/api/survey/insertOtpForExistEmailApi", { email: email, app: "zampliasurveys" })
    .then((response) => response.data);
};

export const verifyIsOtpAreValidateApi = async (email: string, otp: string) => {
  return axiosClient
    .post("/api/survey/verifyIsOtpAreValidateApi", { email: email, otp: otp})
    .then((response) => response.data);
};

export const updatePasswordForExistEmailApi = async (email: string, type: string, password: string) => {
  return axiosClient
    .post("/api/survey/updatePasswordForExistEmailApi", { email: email, type: type, password: password })
    .then((response) => response.data);
};

export const checkUserExistOrNotApi = async (email: string) => {
  return axiosClient
    .get("/api/survey/checkUserExistOrNot", { params: { emailId: email } })
    .then((response) => response.data);
};
